import { Box, Image } from '@chakra-ui/react';
import { useRouter } from 'next/router';
import React from 'react';
import { useIsFetching } from '@tanstack/react-query';

/**
 * Global full-screen loader overlay.
 * Appears whenever a route change is happening or React Query is fetching.
 * Renders above page skeletons without affecting layout.
 */
const LoaderOverlay = () => {
  const router = useRouter();
  const [routeLoading, setRouteLoading] = React.useState(false);

  React.useEffect(() => {
    const start = () => setRouteLoading(true);
    const done = () => setRouteLoading(false);

    router.events.on('routeChangeStart', start);
    router.events.on('routeChangeComplete', done);
    router.events.on('routeChangeError', done);

    return () => {
      router.events.off('routeChangeStart', start);
      router.events.off('routeChangeComplete', done);
      router.events.off('routeChangeError', done);
    };
  }, [router.events]);

  // TanStack Query – number of ongoing fetches anywhere in the app
  const inFlightQueries = useIsFetching();

  const show = routeLoading || inFlightQueries > 0;
  if (!show) return null;

  return (
    <Box
      position="fixed"
      inset={0}
      zIndex="overlay" // sits above tooltips & modals
      bg="rgba(0,0,0,0.7)"
      display="flex"
      alignItems="center"
      justifyContent="center"
    >
      <Image
        src="/L1X-Animation.gif"
        alt="Loading..."
        boxSize="80px"
      />
    </Box>
  );
};

export default LoaderOverlay;
